import httpClient from '../../httpClient';

export const getServiceOrders = (pageNumber, searchInput) => {
  return httpClient({
    method: 'GET',
    url: '/super-admin/service-orders',
    params: {
      pageNumber,
      searchTerm: searchInput,
    },
  });
};

export const getIndividualServiceOrder = (serviceOrderId) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/service-orders/${serviceOrderId}`,
  });
};

export const updateServiceOrderStatus = (data) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/service-orders/${data.serviceOrderId}/status/update`,
    data,
  });
};

export const getInventoryOrders = (pageNumber, searchInput) => {
  return httpClient({
    method: 'GET',
    url: '/super-admin/inventory-orders',
    params: {
      pageNumber,
      searchTerm: searchInput,
    },
  });
};

export const getIndividualInventoryOrder = (inventoryOrderId) => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/inventory-orders/${inventoryOrderId}`,
  });
};

export const updateInventoryOrderStatus = (data) => {
  return httpClient({
    method: 'PUT',
    url: `/super-admin/inventory-orders/${data.inventoryOrderId}/status/update`,
    data,
  });
};

export const getOrderLiveLink = (serviceOrderId) =>
  httpClient({
    method: 'GET',
    url: `/super-admin/service-orders/${serviceOrderId}/live-link`,
  });
